import _Promise from 'babel-runtime/core-js/promise';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _typeof from 'babel-runtime/helpers/typeof';


import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import $ from 'jquery';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import MintUI from 'mint-ui';
import { MessageBox } from 'mint-ui';
import { Indicator } from 'mint-ui';
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
import { utils } from "./assets/public.js";
import 'mint-ui/lib/style.css';
import 'vant/lib/index.css';
import less from 'less';
import globalVariable from '../static/mathjax';
Vue.prototype.commonsVariable = globalVariable;
import Radio from 'vux/src/components/radio/index.vue';

import Group from 'vux/src/components/group/index.vue';

import Tabbar from 'vux/src/components/tabbar/tabbar.vue';
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue';

import PopupRadio from 'vux/src/components/popup-radio/index.vue';

import Datetime from 'vux/src/components/datetime/index.vue';

import Checker from 'vux/src/components/checker/checker.vue';
import CheckerItem from 'vux/src/components/checker/checker-item.vue';

import XTextarea from 'vux/src/components/x-textarea/index.vue';

import Card from 'vux/src/components/card/index.vue';

import XInput from 'vux/src/components/x-input/index.vue';

import Cell from 'vux/src/components/cell/index.vue';

import XDialog from 'vux/src/components/x-dialog/index.vue';

import PopupHeader from 'vux/src/components/popup-header/index.vue';

import Popup from 'vux/src/components/popup/index.vue';

import Icon from 'vux/src/components/icon/index.vue';

import XSwitch from 'vux/src/components/x-switch/index.vue';

import DatetimePlugin from 'vux/src/plugins/datetime/index.js';

import XButton from 'vux/src/components/x-button/index.vue';

import Popover from 'vux/src/components/popover/index.vue';

import Range from 'vux/src/components/range/index.vue';

import Checklist from 'vux/src/components/checklist/index.vue';

import LoadingPlugin from 'vux/src/plugins/loading/index.js';

import Vant from 'vant';
import * as echarts from 'echarts';

Vue.prototype.$echarts = echarts;
Vue.use(Vant);
Vue.use(LoadingPlugin);
Vue.component('checklist', Checklist);
Vue.component('range', Range);
Vue.component('popover', Popover);
Vue.component('x-button', XButton);
Vue.use(DatetimePlugin);
Vue.component('x-switch', XSwitch);
Vue.component('icon', Icon);
Vue.component('popup', Popup);
Vue.component('popup-header', PopupHeader);
Vue.component('x-dialog', XDialog);
Vue.component('cell', Cell);
Vue.component('x-input', XInput);
Vue.component('card', Card);
Vue.component('x-textarea', XTextarea);
Vue.component('checker', Checker);
Vue.component('checker-item', CheckerItem);
Vue.component('datetime', Datetime);
Vue.component('popup-radio', PopupRadio);
Vue.component('tabbar', Tabbar);
Vue.component('tabbar-item', TabbarItem);
Vue.component('radio', Radio);
Vue.component('group', Group);
Vue.use(preview);
Vue.use(MintUI);
Vue.use(ElementUI);
Vue.use(less);
Vue.prototype.utils = utils;
Vue.prototype.$http = axios;
Vue.prototype.CryptoJS = CryptoJS;
Vue.config.productionTip = false;

var _key = '65236514';
var keyHex = CryptoJS.enc.Utf8.parse(_key);

var cancel,
    promiseArr = {};
var CancelToken = axios.CancelToken;
axios.defaults.baseURL = '/xclient';

axios.defaults.headers = { //设置默认请求头
  'X-Requested-With': 'XMLHttpRequest'
};
axios.defaults.timeout = 1000 * 60 * 5;
var count = 0;

axios.interceptors.request.use(function (config) {

  if (config.method == 'get') {
    config.baseURL = '';
    return config;
  }
  if (_typeof(config.data) == 'object') {
    config.data.orgCode = localStorage.getItem("orgCode") ? localStorage.getItem("orgCode") : '';
  }
  console.log('请求报文:', config.data);
  var params = _JSON$stringify(config.data);
  var encryparams;
  if (typeof config.data === "string") {
    encryparams = CryptoJS.DES.encrypt(config.data, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    config.data = encryparams.ciphertext.toString(CryptoJS.enc.Base64);
  } else {
    encryparams = CryptoJS.DES.encrypt(params, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    config.data = {
      params: encryparams.ciphertext.toString(CryptoJS.enc.Base64)
    };
  }

  if (promiseArr[config.url]) {
    promiseArr[config.url]('操作取消');
    promiseArr[config.url] = cancel;
  } else {
    promiseArr[config.url] = cancel;
  }

  Indicator.open("");
  count++;
  return config;
}, function (error) {
  return _Promise.reject(error);
});

axios.interceptors.response.use(function (response) {

  count--;
  if (count <= 0) {
    Indicator.close();
  }
  if (typeof response.data === "string") {
    var result = CryptoJS.DES.decrypt({
      ciphertext: CryptoJS.enc.Base64.parse(response.data)
    }, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    response.data = JSON.parse(result.toString(CryptoJS.enc.Utf8));
  }
  if (response.data.ERRORINFO && response.data.ERRORINFO != "" && response.data.ERRORCD != 'NOTFOUND') {
    MessageBox('提示', response.data.ERRORINFO);
    return;
  }

  console.log('返回报文:', response.data);

  return response.data;
}, function (error) {
  if (error) {
    console.log(error);

    if (error.response) {

      if (error.response.status == 518) {
        //登录失效，跳登录页面，只提示一次
        location.href = location.origin + location.search;
        localStorage.setItem("userId", "");
        localStorage.setItem("orgCode", "");
        localStorage.setItem("stuId", "");
        localStorage.setItem("user", "");
        localStorage.setItem("roleId", "");
        localStorage.setItem("name", "");
        localStorage.setItem("profilePhoto", "");
        sessionStorage.setItem("loginSts", "");
      } else {
        MessageBox('服务升级', '服务正在升级中，请稍后再试');
        console.log(error);
      }
    }
  }
  count--;
  if (count <= 0) {
    Indicator.close();
  }
  return _Promise.resolve(error.response);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  components: {
    App: App
  },
  template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js